/**
 * Feature flags — tek yerden kontrol.
 * Satın alma akışını aktif etmek için PURCHASE_ENABLED = true yap.
 */
export const FEATURES = {
  PURCHASE_ENABLED: false, // Gecici olarak kapali; true yapinca aktif olur
};
